import React from "react";
import "./component.css";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";

const ActivateComponent = (props) => {
  return (
    <div className="form-row">
      {props.activateTag.map((input, index) => (
        <Box key={index} className="form-field">
          <div className="input-group">
            <TextField
              fullWidth
              label="UID"
              name={`uid${index}`}
              value={input.uid}
              onChange={(event) => props.handleActivateInputChange(event, index, "uid")}
            />
            <TextField
              fullWidth
              label="Token"
              name={`token${index}`}
              value={input.token}
              onChange={(event) => props.handleActivateInputChange(event, index, "token")}
            />
            <div className="checkbox-container">
              <input
                type="checkbox"
                className="custom-checkbox"
                checked={input.isChecked}
                onChange={() => props.handleCheckboxClick(index)}
              />
            </div>
          </div>
        </Box>
      ))}
    </div>
  );
};

export default ActivateComponent;